export { default } from './ArtistMenu';
